import { Component, OnInit } from '@angular/core';
import { MainserviceService } from './../mainservice.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-malls',
  templateUrl: './malls.component.html',
  styleUrls: ['./malls.component.scss']
})
export class MallsComponent implements OnInit {

  mallFilter:any = { name: ''}
  p: number = 1; 

  malls:any;
  constructor(private mainServ: MainserviceService,
              private router: Router
    ) { }

  ngOnInit() {
    this.mainServ.getMalls().subscribe(data => {
      this.malls = data
    });
  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/malls/malls.component.ts